import styled from 'styled-components';
import { LauncherElementData, useLauncherElementsStore } from '../../../../hooks/stores/launcherElementsStore';
import { UIData, useUIStore } from '../../../../hooks/stores/uiStore';
import { IconSelectInput } from '../../baseInputs/IconSelectInput';
import { useScene } from '../../../../context/sceneContext';

export const PositioningSimplifiedInput = () => {
  const scene = useScene();
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();
  const [UIData] = useUIStore<UIData>({ selector: ['selectedElementIDs'] });
  const selectedElement = launcherElementsData[UIData.selectedElementIDs?.slice(-1)[0]];
  const selectedElementType = selectedElement?.type;

  const updateValue = (key: string, value?: string | number) => {
    scene.updateSelectedElementsData(
      { [key]: value, display: selectedElementType === 'popup' ? 'none' : 'flex', textOverflow: undefined },
      'props.class',
      'positioningSimplifiedInput'
    );
  };

  const data = scene.getSelectedElementsData(
    {
      display: undefined,
      flexDirection: 'row',
      justifyContent: undefined,
      alignItems: undefined,
    },
    'props.class'
  );

  return (
    <Row style={{ padding: '4px 15px', justifyContent: 'space-evenly' }}>
      <IconSelectInput
        value={data.flexDirection === 'row' ? data.justifyContent : data.alignItems}
        defaultValue={data.display === 'flex' ? 'flex-start' : undefined}
        data={[
          {
            value: 'flex-start',
            iconClassName: 'icon-positioning-left',
            iconStyle: { fontSize: '13px' },
            id: 'position-horizontal-left',
            tooltip: 'Horizontal Left',
          },
          {
            value: 'center',
            iconClassName: 'icon-positioning-center',
            iconStyle: { fontSize: '13px' },
            id: 'position-horizontal-center',
            tooltip: 'Horizontal Center',
          },
          {
            value: 'flex-end',
            iconClassName: 'icon-positioning-left',
            iconStyle: { transform: 'rotate(180deg)', fontSize: '13px' },
            id: 'position-horizontal-right',
            tooltip: 'Horizontal Right',
          },
        ]}
        onChange={(newValue) => updateValue(data.flexDirection === 'row' ? 'justifyContent' : 'alignItems', newValue)}
      />
      <IconSelectInput
        value={data.flexDirection === 'row' ? data.alignItems : data.justifyContent}
        defaultValue={data.display === 'flex' ? 'flex-start' : undefined}
        data={[
          {
            value: 'flex-start',
            iconClassName: 'icon-positioning-left',
            iconStyle: { transform: 'rotate(90deg)', fontSize: '13px' },
            id: 'position-vertical-left',
            tooltip: 'Vertical Top',
          },
          {
            value: 'center',
            iconClassName: 'icon-positioning-center',
            iconStyle: { transform: 'rotate(90deg)', fontSize: '13px' },
            id: 'position-vertical-center',
            tooltip: 'Vertical Center',
          },
          {
            value: 'flex-end',
            iconClassName: 'icon-positioning-left',
            iconStyle: { transform: 'rotate(-90deg)', fontSize: '13px' },
            id: 'position-vertical-right',
            tooltip: 'Vertical Bottom',
          },
        ]}
        onChange={(newValue) => updateValue(data.flexDirection === 'row' ? 'alignItems' : 'justifyContent', newValue)}
      />
    </Row>
  );
};

const Row = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  gap: 5px;
`;
